import React from 'react';

import { TEnvironmentContext } from 'types/EnvironmentContext';

const defaultValues: TEnvironmentContext = {
  staticBaseUrl: '',
  xsrfToken: '',
  tenantContext: {
    tenant: 'mp',
    locale: 'nl',
  },
  baseUrl: '',
  links: {},
  reviewee: {},
  summary: {},
  reviews: {},
  userReviewContext: {},
  isForbiddenForReview: false,
};

const EnvironmentContext = React.createContext(defaultValues);

export const EnvironmentProvider = EnvironmentContext.Provider;
export const EnvironmentConsumer = EnvironmentContext.Consumer;

export default EnvironmentContext;
